export default "__VITE_ASSET__DhPgCioN__"